/**
 * Status de combate (Fase 8, doc 09 §3.5): o que as habilidades aplicam em criaturas e jogadores. Cada um
 * tem um glifo (lido sem cor) e efeitos simples; quem aplicou dá a cor (a regra "cor = fonte").
 */
export const STATUS_IDS = ["provocado", "preso", "lento", "marcado", "exposto", "protegido"] as const;
export type StatusId = (typeof STATUS_IDS)[number];

export interface StatusDef {
  readonly id: StatusId;
  readonly name: string;
  /** Glifo sobre o alvo e no quadro do grupo. */
  readonly glyph: string;
  /** Duração padrão (ms), quando a habilidade não diz outra. */
  readonly durationMs: number;
  /** Multiplicador da velocidade (Preso = 0). */
  readonly speedMul: number;
  /** Multiplicador do dano recebido. */
  readonly damageTakenMul: number;
  /** Multiplicador do dano de postura recebido. */
  readonly postureMul: number;
  /** Teto do dano por golpe nos chefes (fração da vida), quando o status sobe o normal (5 %). */
  readonly hitCap?: number;
}

/** A postura a mais em Preso e Marcado é do Ímpeto do Lanceiro (`impetusPosture`), não do status (F77). */
export const STATUSES: readonly StatusDef[] = [
  { id: "provocado", name: "Provocado", glyph: "!", durationMs: 4000, speedMul: 1, damageTakenMul: 1, postureMul: 1 },
  { id: "preso", name: "Preso", glyph: "⛓", durationMs: 1500, speedMul: 0, damageTakenMul: 1, postureMul: 1 },
  { id: "lento", name: "Lento", glyph: "≈", durationMs: 2000, speedMul: 0.6, damageTakenMul: 1, postureMul: 1 },
  { id: "marcado", name: "Marcado", glyph: "⌖", durationMs: 5000, speedMul: 1, damageTakenMul: 1.1, postureMul: 1 },
  { id: "exposto", name: "Exposto", glyph: "◎", durationMs: 6000, speedMul: 1, damageTakenMul: 1.25, postureMul: 1.5, hitCap: 0.075 },
  { id: "protegido", name: "Protegido", glyph: "⛨", durationMs: 6000, speedMul: 1, damageTakenMul: 0.75, postureMul: 1 },
];

/** Antes de acabar, o glifo pisca (F76, doc 09 §2.3): a janela, em ms. */
export const STATUS_ENDING_MS = 1000;

export const STATUS_BY_ID: ReadonlyMap<StatusId, StatusDef> = new Map(STATUSES.map((s) => [s.id, s]));

/** Nos chefes, Preso e Provocado duram menos (doc 09 §3.3): Preso vira só lento, e a provocação dura 2 s. */
export const BOSS_STATUS_RULES = { tauntMs: 2000, tauntImmunityMs: 20000, rootBecomes: "lento" as StatusId } as const;
